var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M5.05,10.31c-0.25,0.22-0.39,0.51-0.39,0.82c0,0.31,0.14,0.6,0.39,0.82l6.01,5.26c0.12,0.11,0.27,0.2,0.43,0.25c0.33,0.12,0.69,0.12,1.01,0c0.16-0.06,0.31-0.14,0.43-0.25l6.02-5.26c0.52-0.45,0.52-1.19,0-1.64c-0.52-0.45-1.36-0.45-1.88,0l-3.75,3.28V3.95c0-0.64-0.6-1.05-1.33-1.05s-1.33,0.41-1.33,1.05v9.64l-3.75-3.28C6.41,9.86,5.56,9.86,5.05,10.31z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M20.7,21.1H3.3c-0.72,0-1.3-0.58-1.3-1.3v-3.7c0-0.72,0.58-1.3,1.3-1.3s1.3,0.58,1.3,1.3v2.4h14.78v-2.4c0-0.72,0.58-1.3,1.3-1.3s1.3,0.58,1.3,1.3v3.7C22,20.52,21.42,21.1,20.7,21.1z","key":1})]);
}

DownloadIcon.defaultProps = {"data-dmid":"dm-download","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
